module.exports = __webpack_public_path__ + "static/media/lunch_room.4acaf5b0.jpg";